@if (getPreviewPackage$(messageId) | async; as previewPackage) {
  <div
    class="rounded-full bg-black/40 !max-h-8 !max-w-8 flex items-center justify-center mr-2 cursor-pointer"
    #wrapper
  >
    <mat-icon
      class="text-white"
      [matTooltip]="preview_tooltip"
      matTooltipPosition="left"
      matTooltipClass="preview_tooltip"
      matTooltipPositionAtOrigin="false"
      #icon
      >visibility</mat-icon
    >
  </div>
  <ng-template #preview_tooltip>
    @if (shareCurrentMessage || messageId === -1) {
      <div class="share_current">分享訊息：分享這則訊息</div>
    } @else {
      <div #messagePreview class="share_normal">
        @for (
          message of previewPackage.messages;
          track message;
          let index = $index
        ) {
          <div>
            <ms-factory
              [package]="previewPackage"
              [message]="message"
              class="!m-0 !p-0"
              [style.width]="
                message.type === 'poster' || message.type === 'text'
                  ? '400px'
                  : 'auto'
              "
              (viewInitEmitter)="
                index === previewPackage.messages.length - 1
                  ? resizePreview(messagePreview)
                  : null
              "
            ></ms-factory>
          </div>
        }
      </div>
    }
  </ng-template>
}
